import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";

export default function LoginHistory() {
  const [lists, setLists] = useState([]);
  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(100);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const userId = localStorage.getItem("userId");

  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETLOGINHISTORY +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize,
        { ...headerconfig }
      )

      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };

  const onDelete = (e, id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETELOGINHISTORY + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            GetData(pageNumber);
          } else {
            handleError(response.data.data);
            GetData(pageNumber);
          }
        });
    }
  };

  const getStatusClass = (status) => {
    if (!status) return "badge bg-secondary";

    const statusLower = status.toLowerCase();
    if (statusLower.includes("success")) {
      return "badge bg-success";
    } else if (statusLower.includes("failed - inactive")) {
      return "badge bg-warning text-dark";
    } else if (statusLower.includes("failed")) {
      return "badge bg-danger";
    }
    return "badge bg-secondary";
  };

  useEffect(() => {
    GetData(pageNumber);
  }, [pageNumber]);

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Login History</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>S.NO</th>
                            <th>Username</th>
                            <th>IP Address</th>
                            <th>Login Time</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((v, index) => (
                            <tr key={v.loginHistoryId}>
                              <td>
                                {(pageNumber - 1) * pageSize + (index + 1)}
                              </td>
                              <td>{v.username}</td>
                              <td>{v.ipAddress}</td>
                              <td>
                                {moment(v.loginTime).format(
                                  "DD-MMM-YYYY hh:mm A"
                                )}
                              </td>
                              <td>
                                <span className={getStatusClass(v.status)}>
                                  {v.status?.toUpperCase()}
                                </span>
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li>
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        onDelete(e, v.loginHistoryId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={`page-item ${
                            pageNumber === 1 ? "disabled" : ""
                          }`}
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>

                        {renderPageNumbers}
                        <li
                          className={`page-item ${
                            pageNumber === totalPages ? "disabled" : ""
                          }`}
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
